import React from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import {faDownload} from '@fortawesome/free-solid-svg-icons/faDownload';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import config from '../../../config/app';

const DownloadReceipt = props => {

  const {receipt} = props;
  const {api_file_receipt} = config;

  return (
    <a target="_blank" href={api_file_receipt + receipt.id + '?token=' + receipt.file.token} className="btn-update" id="downloadButton" rel="noopener noreferrer">
      <FontAwesomeIcon icon={faDownload} color="#329aef" size="sm" />
    </a>
  );
};

DownloadReceipt.propTypes = {
  receipt: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(DownloadReceipt);
